import axios from 'axios'

const axiosObj = axios.create({
  baseURL: `${process.env.REACT_APP_ADMIN_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json'
})

const idleTimeReasonService = {
  addIdleTimeReasons: async (data) => {
    try {
      const response = await axiosObj.post('/idleTime-reasons', data)
      return response.data
    } catch (err) {
      console.log(err)
      return err.response
    }
  },
  getIdleTimeReasons: async () => {
    try {
      const response = await axiosObj.get('/idleTime-reasons', {
      })
      return response.data
    } catch (err) {
      console.log(err)
      return err.response
    }
  }
}

export default idleTimeReasonService
